// @ts-nocheck
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";
import { InvoicePaymentSuccessModel } from "@store/Framework/Types/ApiModels";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface InvoicePaymentContextModel {
    errorMessage?: string;
    invalidInvoiceIds: string[];
    invoiceIds: string[];
    invoices: InvoiceModel[];
    isLoading?: boolean;
    isSubmitting?: boolean;
    paymentErrorMessage?: string;
    setIsSubmitting: Dispatch<SetStateAction<boolean>>;
    setPaymentErrorMessage: Dispatch<SetStateAction<string>>;
    setPaymentSuccess: Dispatch<SetStateAction<InvoicePaymentSuccessModel | undefined>>;
    paymentSuccess?: InvoicePaymentSuccessModel;
    termDiscount: number;
    total: number;
}

export const InvoicePaymentContext = createContext<InvoicePaymentContextModel>({} as any);

export const useInvoicePaymentContext = () => useContext(InvoicePaymentContext);
